export default __webpack_public_path__ + "static/peace-a6ff96eae6a850900ad37856b1021c7f.png";